/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { divider, leftIcon, modalContainer } from "@/src/theme/commonStyle";
import { Theme } from "@mui/material";

const applicationFormStyle = {
  modalContainer,
  divider,
  paper: {
    padding: "2rem",
  },
  applicationForm: {
    maxWidth: "650px",
    margin: "0 auto",
  },
  headline: {
    textAlign: "center",
    fontWeight: "bold",
  },
  subheadline: {
    textAlign: "center",
  },
  question: {
    textAlign: "center",
    fontSize: "1.25rem",
    lineHeight: 1.5,
  },
  gridSpace: (theme: Theme) => ({
    [theme.breakpoints.up("sm")]: {
      paddingRight: "3rem",
    },
  }),
  gridSpaceMd: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      paddingRight: "3rem",
    },
  }),
  gridTopSpaced: {
    paddingTop: "1rem",
  },
  gridMargin: (theme: Theme) => ({
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "1rem",
    },
  }),
  info: {
    height: "1.25rem",
    cursor: "help",
  },
  formSpacer: {
    marginTop: "1.25rem",
  },
  checkboxFormControl: (theme: Theme) => ({
    marginTop: { xs: 0, sm: "1rem" },
    [theme.breakpoints.up("sm")]: {
      paddingTop: "1rem",
    },
  }),
  powerOfAttorney: {
    marginBottom: "auto",
  },
  insuranceBox: {
    textAlign: "center",
    border: "1px solid " + "primary.main",
    borderRadius: "5px",
    padding: "0.5rem",
    marginTop: "1.5rem",
  },
  noRisk: {
    color: "primary.main",
    fontWeight: 500,
  },
  primary: {
    color: "primary.main",
  },
  signatureCaption: {
    textAlign: "center",
  },
  signatureImage: {
    maxWidth: "100%",
  },
  signatureButton: {
    width: "280px",
  },
  leftIcon,
};

export default applicationFormStyle;
